export default "<p>\n  video-upload works!\n</p>\n";